import { Divider, Menu, MenuItem } from '@mui/material'
import React from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const ArrowButton = ({ handleMenuClick, anchorEl, handleMenuClose, handleAddClick, menuText, handleCloneTest, reviewStageCount, guard }: any) => {

    const path = window.location.href.includes('test')



    return (
        <>
            <Divider orientation="vertical" flexItem sx={{ height: '1px' }} />

            <ArrowDropDownIcon fontSize='small' onClick={handleMenuClick} sx={{
                width: '30px',
                height: '40px',
                marginTop: '10px',
                color: 'white',
                borderRadius: '0 8px 8px 0',
                padding: '8px, 16px, 8px, 16px',
                backgroundColor: '#3D85C6',
                '&:hover': {
                    backgroundColor: '#3D85C6',
                },
            }} />
            <Menu
                id="invite-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleAddClick}>{menuText}</MenuItem>

                {path ? <><Divider /> <MenuItem onClick={reviewStageCount <= 0 ? guard : () => handleCloneTest("Clicked Clone test")}>{"Clone Test"}</MenuItem></> : null}
            </Menu>
        </>
    )
}

export default ArrowButton